"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackBannerEvent = void 0;
const config_1 = require("../components/organisms/Modals/InfoBanner/config");
/**
 * Push an InfoBanner A/B event to the GTM dataLayer. Fire-and-forget: if GTM is
 * not loaded (no cookie consent) the push is harmless and simply never forwarded.
 * Mirrors HabitatMap's airbeam-ab.js push shape.
 */
const trackBannerEvent = ({ event, variant, postSlug, }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event,
        banner_source: config_1.BANNER_SOURCE,
        banner_campaign: config_1.BANNER_CAMPAIGN,
        banner_variant: variant,
        post_slug: postSlug,
    });
};
exports.trackBannerEvent = trackBannerEvent;
